import { SkeletonLines } from "components/new-stuff/ui/Skeleton"
import React, { useState } from "react"
import { LoadingOutlined } from "@ant-design/icons"

type props = {
  title?: string
  subTitle?: string
  tabList?: {
    key: string
    label: React.ReactNode
    tab: React.ReactNode
  }[]
  children?: React.ReactNode
  activeTabKey?: string
  onTabChange?: (key: string) => void
  rootClassName?: string
  headerClassName?: string
  childrenWrapperClassName?: string
  ctaBtn?: React.ReactNode
  loading?: boolean
  /**
   * What to draw while loading, in place of the default lines. Pass a shaped placeholder --
   * a chart card drawing four flat lines changes shape entirely when the chart lands.
   */
  placeholder?: React.ReactNode
  id?: string
}
const CustomCard: React.FC<props> = ({
  title,
  subTitle,
  tabList = [],
  activeTabKey,
  children = null,
  ctaBtn,
  onTabChange = () => {},
  loading = false,
  placeholder,
  rootClassName = "",
  headerClassName = "",
  childrenWrapperClassName = "",
  id,
}) => {
  const antIcon = (
    <LoadingOutlined
      style={{ fontSize: 24 }}
      spin
    />
  )
  return (
    <div
      id={id}
      className={`bg-white border rounded-xl p-4 lg:p-5 ${rootClassName}`}
    >
      <>
        <div
          className={`flex justify-between items-center mb-3 gap-4 ${headerClassName}`}
        >
          <div className="">
            {title ? (
              <h5 className="font-circular text-base text-padeBlack font-semibold ">
                {title}
              </h5>
            ) : null}
            {subTitle ? (
              <span className="font-avenir text-padeSubtext text-sm">
                {subTitle}
              </span>
            ) : null}
          </div>
          {ctaBtn ? ctaBtn : null}
        </div>
        {tabList?.length > 0 && (
          <div className="font-avenir">
            <div
              className={`border grid grid-flow-col border-cardgrey rounded-[5px]`}
            >
              {tabList?.map((tab) => (
                <button
                  key={tab.key}
                  className={` py-1 text-sm min-h-[27px] ${
                    activeTabKey == tab.key
                      ? "bg-primary500 rounded-[5px] text-a11y"
                      : "bg-grey10 text-neutral500"
                  }`}
                  onClick={() => {
                    onTabChange(tab.key)
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="mt-5 max-h-[360px] max-w-full overflow-auto">
              {tabList?.find((tab) => tab.key === activeTabKey)?.tab}
            </div>
          </div>
        )}
        {loading ? (
          <div
            className={`${childrenWrapperClassName} font-avenir flex flex-col gap-3 pt-2`}
            aria-busy="true"
          >
            {placeholder ?? <SkeletonLines lines={4} />}
          </div>
        ) : (
          children && (
            <div className={`${childrenWrapperClassName} font-avenir`}>
              {children}
            </div>
          )
        )}
      </>
    </div>
  )
}

export default CustomCard
